import { useGetLevelDetails } from "../../Controllers/DashboardController";
import ProgressBar from "../ProgressBar";
import SingleLineSkeletonLoader from "../SkeletonLoaders/SingleLineSkeletonLoader";

const LevelProgressBar = () => {
  const { data: levelDetailsData, isLoading: levelDetailsLoading } =
    useGetLevelDetails();

  const levelDetails = levelDetailsData?.level_details || null;

  if (levelDetailsLoading) {
    return <SingleLineSkeletonLoader />;
  }

  return (
    <div className="level-content">
      <div className="level-info">
        <span className="text-body-b1">
          Level {levelDetails?.current_level}
        </span>
        <span className="text-body-b3">
          Needs {levelDetails?.point_remaining_for_next_level} points to level{" "}
          {levelDetails?.next_level}
        </span>
      </div>
      <div className="progress-wrapper">
        <ProgressBar
          progressPercentage={levelDetails?.progress_percentage ?? 0}
        />
        <div className="points-display">
          <span className="text-body-b3">
            {levelDetails?.total_points_of_user}
          </span>
          <span className="text-body-b3">
            {levelDetails?.total_points_for_next_level}
          </span>
        </div>
      </div>
    </div>
  );
};

export default LevelProgressBar;
